import React, { ReactElement } from 'react';
import { Chart, registerables } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import FlexContainer from '../flex-container/flex-container.component';
import FormatService from '../../services/format-service';
import ChartPluginPieChartDataLabels from '../../services/chart-plugins/chart-plugin-pie-chart-data-labels';
import { ACCENT_COLORS_CONTRAST } from '../../constants/system/colors';

const ChartPie: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CHART_PIE_HEIGHT: number = 280;
  const CHART_PIE_WIDTH: number = 640;
  const CHART_PIE_PADDING_TOP: number = 20;
  const CHART_PIE_BORDER_WIDTH: number = 2;
  const CHART_PIE_PADDING: number = 10;
  const CHART_PIE_LEGEND_POSITION_RIGHT: ChartLayoutPosition = 'right';
  const CHART_PIE_LEGEND_BOX_WIDTH: number = 12;

  const {
    containerId,
    chartItemList,
  } = props;

  const itemsTotal: number = chartItemList && chartItemList.length
    ? chartItemList.reduce((chartItemsTotal: number, chartItem: ChartPieItem): number => (
      chartItemsTotal + chartItem.value
    ), 0) : 0;

  const chartPieLabelList: string[] = chartItemList.map((chartItem: ChartPieItem): string => chartItem.name);
  const chartPieValueList: number[] = chartItemList.map((chartItem: ChartPieItem): string => (
    Math.floor((chartItem.value / itemsTotal) * 100).toFixed(FormatService.FLOAT_NUMBER_PRECISION_SHORT)
  ));

  Chart.register(...registerables);

  return (
    <FlexContainer
      isCentered
      withSpaceAround
      id={containerId}
      style={{
        height: CHART_PIE_HEIGHT,
        paddingTop: CHART_PIE_PADDING_TOP,
      }}
    >
      {
        chartItemList && !!chartItemList.length && (
          <Pie
            id={containerId}
            height={CHART_PIE_HEIGHT}
            width={CHART_PIE_WIDTH}
            data={{
              labels: chartPieLabelList,
              datasets: [
                {
                  label: '',
                  data: chartPieValueList,
                  borderWidth: CHART_PIE_BORDER_WIDTH,
                  backgroundColor: ACCENT_COLORS_CONTRAST,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  display: false,
                  grid: {
                    display: false,
                  },
                },
                y: {
                  display: false,
                  grid: {
                    display: false,
                  },
                },
              },
              layout: {
                padding: CHART_PIE_PADDING,
              },
              plugins: {
                tooltip: {
                  callbacks: {
                    label: (context: ChartInstance): string => {
                      return context.dataset.label;
                    },
                  },
                },
                legend: {
                  position: CHART_PIE_LEGEND_POSITION_RIGHT,
                  labels: {
                    boxWidth: CHART_PIE_LEGEND_BOX_WIDTH,
                  },
                },
              },
            }}
            plugins={[ChartPluginPieChartDataLabels]}
          />
        )
      }
    </FlexContainer>
  );
});

export default ChartPie;
